<template>
        <a-card class="card-border" style="border: 0px; border-bottom: 1px solid #e1e4e8;" :bodyStyle="{padding: '10px', textAlign: 'left'}">
          <a-row>
            <a-col :span="20">
              <h3><a :href="item.url" target="_black"> {{item.title}} </a></h3>
            </a-col>
            <a-col :span="4" style="text-align: right">
              <h3><a @click="showQrcode()" style="color: rgb(24, 144, 255)">生成广告页面</a></h3>
            </a-col>
          </a-row>
          <a-row>
            <p class="text-all" v-if="item.content && item.showdetail"> {{item.content}}</p>
            <p class="text-split" v-if="item.content && !item.showdetail">{{item.content}}</p>
          </a-row>
          <!-- comments @following="followItem" @deleteitem="deleteComments" @additem="addComments" :item="item"/-->
        </a-card>
</template>

<script>

export default {
  name: 'AdsItem',
  props: {
    item: {
      default: function() {
        return {
        }
      }
    },
    index: {
      type: Number,
      default: function() {
        return 0
      }
    }
  },
  data() {
    return {
    }
  },
  components: {
  },
  filters: {
    TimeChange(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + MM + "-" + d;
   }
  },
  methods: {
    showQrcode: function() {
      this.$emit('qrcode', this.item.news_id, this.item.url);
    },
    followItem: function(item, value) {
      item.profile['like'] = value;
      let postdata = {
            "task": "ADD_PROFILE_LIKE",
             type: 'news',
             source: item.news_id,
             like: value
          };
      let that = this;
      that.post("profile", postdata)
        .then(function(response) {
          that.item = item;
          that.$store.commit('updateresultitem', that.item, that.index);
        }).catch(function (e) {
          that.$message.error('修改失败');
     });
    },
    addComments: function(content, item) {
      let postdata = {
        task: "ADD_PROFILE_COMMENT",
        type: "news",
        source: item.news_id,
        content: content
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          if (!item.profile) {
            item.profile = {};
          }
          if (!item.profile.comments) {
            item.profile.comments = [];
          }
          item.profile.comments.push({"content": content, "time": (new Date()).valueOf()});
          that.item = item;
          that.$store.commit('updateresultitem', that.item, that.index);
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },
    deleteComments: function(item, order) {
      let postdata = {
        task: "DELETE_PROFILE_COMMENT",
        type: "news",
        source: item.news_id,
        order: order
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          let tp = item["profile"];
          let comments = [];
          for (let i = 0; i < tp.comments.length; i++) {
            if (i != Number(order)) {
              comments.push(tp.comments[i]);
            }
          }
          item["profile"]["comments"] = comments;
          that.item = item
          that.$store.commit('updateresultitem', that.item, that.index);
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },
    showDetails: function() {
      let item = this.item;
      if (item["showdetail"] && item["showdetail"] == true) {
        item["showdetail"] = false;
        this.item = item;
        return;
      }
      if (item["showdetail"] && item["showdetail"] == false) {
        item["showdetail"] = true;
        this.item = item
        return;
      }
      let news_id = item.news_id;
      let postdata = {
        "task": "NEWS_DETAIL",
        "news_id": news_id
      };
      let that = this;
      let loading = that.$message.loading("详细数据获取中...", 0);
      that.post('news', postdata)
        .then(function(data) {
          setTimeout(loading, 0);
          data.data["like"] = item.like ? item.like: 0;
          data.data["profile"] = item.profile ? item.profile: {};
          data.data["showdetail"] = true;
          that.item = data.data;
          that.$store.commit('updateresultitem', data.data, that.index);
        }).catch(function (e) {
          setTimeout(loading, 0);
          that.$message.error("查询失败");
      });
    }
  }
}
</script>

<style scoped>
  .pb8 {
    padding-bottom: 8px;
  }
  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }
  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
